import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewTradeAgreementPage } from './new-trade-agreement.page';
import { RouterModule, Routes } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatSelectModule } from '@angular/material/select';

const routes: Routes = [
  {
    path: '',
    component: NewTradeAgreementPage
  }
];


@NgModule({
  declarations: [
    NewTradeAgreementPage
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatTableModule,
    MatSortModule,
    ComponentsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FormsModule,
    Ng2SearchPipeModule
  ]
})

export class NewTradeAgreementModule { }
